import DataGrid, { Column } from 'devextreme-react/data-grid';
import { formatDate } from '../../common/SharedFunctions';
import { AddNoticeButton, ViewNoticeButton } from '../common/NoticeComponents';
import { Tooltip } from 'devextreme-react/tooltip';

const PortfolioTable = ({ loans }) => {
    const onPropertyRender = (e) => {
        if (
            !e.data.propertyStreet1 &&
            !e.data.propertyStreet2 &&
            !e.data.propertyCity &&
            !e.data.propertyState &&
            !e.data.propertyZip
        ) {
            return <i>Address not set</i>;
        }
        return (
            <>
                {e.data.propertyStreet1}
                {e.data.propertyStreet2 ? `, ${e.data.propertyStreet2}` : ''}
                <br />
                {e.data.propertyCity}, {e.data.propertyState} {e.data.propertyZip}
            </>
        );
    };

    const onNoticeRender = (e) => {
        if (!e.value) {
            return null;
        }

        return e.value.map((n, index) => {
            if (!n.id) {
                if (n.isActive) {
                    return (
                        <AddNoticeButton
                            key={'url' + index}
                            notice={n}
                        />
                    );
                } else {
                    const targetId = `nt_${n.noticeTypeId}_${e.data.id}`;
                    return (
                        <span key={'url' + index}>
                            <div
                                style={{ fontSize: '13px', cursor: 'default' }}
                                data-tip
                                data-for={targetId}
                            >
                                {n.title}
                            </div>
                            {n.tooltip && (
                                <Tooltip
                                    target={`[data-for="${targetId}"]`}
                                    showEvent='mouseenter'
                                    hideEvent='mouseleave'
                                    hideOnOutsideClick={false}
                                >
                                    {n.tooltip}
                                </Tooltip>
                            )}
                        </span>
                    );
                }
            } else
                return (
                    <div key={'url' + index}>
                        <ViewNoticeButton notice={n} />
                    </div>
                );
        });
    };

    const onDateRender = (e) => {
        if (!e.value) {
            return null;
        }
        return formatDate(new Date(e.value));
    };

    const onAppraisalReportHeaderRender = (e) => {
        if (e.rowType !== 'header') {
            return null;
        }
        return (
            <span style={{ color: 'black' }}>
                Appraisal
                <br />
                Report
            </span>
        );
    };

    const onFloodNoticeHeaderRender = (e) => {
        if (e.rowType !== 'header') {
            return null;
        }
        return (
            <span style={{ color: 'black' }}>
                Flood
                <br />
                Notice
            </span>
        );
    };

    const onPostClosingCertNoticeHeaderRender = (e) => {
        if (e.rowType !== 'header') {
            return null;
        }
        return (
            <span style={{ color: 'black' }}>
                Post Close Cert.
                <br />
                Notice
            </span>
        );
    };

    if (!loans || loans.length === 0) {
        return '';
    }

    return (
        <DataGrid
            dataSource={loans}
            showBorders={true}
            showRowLines={false}
            rowAlternationEnabled={true}
            remoteOperations={false}
            allowColumnReordering={false}
            allowColumnResizing={true}
            width={'85%'}
            cellHintEnabled={true}
        >
            <Column
                dataField='propertyStreet1'
                caption='Property'
                cellRender={onPropertyRender}
                allowSorting={false}
            />
            <Column
                dataField='bfiNumber'
                caption='BFI #'
                dataType='string'
                width={120}
            />
            <Column
                dataField='noticesToName'
                caption='User'
                width={150}
            />
            <Column
                dataField='noticesToEmail'
                caption='Address'
                width={200}
            />
            <Column
                dataField='noticesToESign'
                caption='E-Sign'
                width={100}
                cellRender={onDateRender}
            />
            <Column
                dataField='appraisalReports'
                headerCellRender={onAppraisalReportHeaderRender}
                cellRender={onNoticeRender}
                allowSorting={false}
                width={100}
            />
            <Column
                dataField='floodNotices'
                headerCellRender={onFloodNoticeHeaderRender}
                cellRender={onNoticeRender}
                allowSorting={false}
                width={100}
            />
            <Column
                dataField='postClosingCertNotices'
                headerCellRender={onPostClosingCertNoticeHeaderRender}
                cellRender={onNoticeRender}
                allowSorting={false}
                width={120}
            />
        </DataGrid>
    );
};

export default PortfolioTable;
